module.exports = __webpack_public_path__ + "img/icon_star_filled.a1a9790e.svg";